<template>
  <v-slide-x-transition>
    <v-text-field
      v-if="show"
      v-model="searchInput"
      :disabled="!selectedFeature"
      hide-details
      :label="label"
      prepend-inner-icon="search"
    />
  </v-slide-x-transition>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  computed: {
    ...mapState("ner", ["classification", "selectedFeature", "products"]),
    /* Map the state of this input to the store's searchInput */
    searchInput: {
      get() {
        return this.$store.state.ner.searchInput;
      },
      set(value) {
        this.setSearchInput(value);
      }
    },
    show() {
      return !!this.classification && this.products.length;
    },
    label() {
      return this.selectedFeature
        ? "Valor a buscar"
        : "Selecciona un atributo para buscar un valor";
    }
  },
  watch: {
    selectedFeature() {
      if (!this.selectedFeature) {
        this.setSearchInput(null);
      }
    }
  },
  methods: {
    ...mapMutations("ner", ["setSearchInput"])
  }
};
</script>